// services/reportePagosService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

export interface ReportePago {
    codigo: string;
    cliente_info: {
        id: number;
        nombre: string;
        email: string;
    };
    total: number;
    monto_pagado: number;
    deuda_total: number;
    sesiones_detalle: Array<{
        id: number;
        fecha_inicio: string;
        fecha_fin: string;
        horas: number;
        precio_original: number;
        precio_con_descuento: number;
        monto_pagado: number;
        saldo_pendiente: number;
        estado_pago: string;
        pagos: Array<{
            id: number;
            fecha_pago: string;
            monto: number;
            tipo_pago_nombre: string;
            codigo: string;
        }>;
    }>;
    historial_pagos: Array<{
        id: number;
        fecha_pago: string;
        monto: number;
        tipo_pago_nombre: string;
        codigo: string;
        origen: string;
    }>;
}

export const fetchReportePagos = async (codigo: string): Promise<ReportePago> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<ReportePago>(`citas/reporte-pagos/${codigo}/`);
        return response.data;
    });
};

export const buscarCitaPorCodigo = async (codigo: string): Promise<ReportePago> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<ReportePago>('citas/buscar-por-codigo/', {
            params: { codigo }
        });
        return response.data;
    });
};

// ✅ NUEVA FUNCIÓN: usa el endpoint por ID (más eficiente)
export const fetchReportePagoPorCitaId = async (citaId: number): Promise<ReportePago> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<ReportePago>(`citas/${citaId}/reporte-pagos/`);
        return response.data;
    });
};